import { Reorder } from "framer-motion";
import { GripVertical } from "lucide-react";
import { PAGE_SECTIONS, orderedSections } from "@/lib/sections";

// Glisser-déposer l'ordre des sections de la page publique
export default function SectionOrderCard({ page, value, onChange }) {
  const order = orderedSections(page, value);
  const labels = Object.fromEntries(
    PAGE_SECTIONS[page].map((s) => [s.key, s.label]),
  );
  return (
    <div className="space-y-2" data-testid="section-order-card">
      <p className="text-xs text-zinc-500 font-body">
        Glissez-déposez pour choisir l'ordre d'affichage des sections sur la
        page publique (ex. photos en haut ou en bas). Les sections vides ne
        s'affichent pas. Pensez à enregistrer.
      </p>
      <Reorder.Group
        axis="y"
        values={order}
        onReorder={onChange}
        className="space-y-1.5"
      >
        {order.map((k, i) => (
          <Reorder.Item
            key={k}
            value={k}
            data-testid={`section-order-${k}`}
            whileDrag={{ scale: 1.02 }}
            className="flex items-center gap-3 bg-[#0A0B0E] border border-white/10 rounded-md px-3 py-2.5 cursor-grab active:cursor-grabbing select-none touch-none hover:border-[#D4AF37]/40 transition-colors"
          >
            <GripVertical className="w-4 h-4 text-zinc-600 shrink-0" />
            <span className="font-display uppercase text-xs font-bold tracking-wide text-zinc-200 flex-1">
              {labels[k]}
            </span>
            <span className="text-[10px] text-zinc-600 font-bold tabular-nums">
              {i + 1}
            </span>
          </Reorder.Item>
        ))}
      </Reorder.Group>
    </div>
  );
}
